import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", {
  state: () => ({
    is_full_screen: false, // 是否是全屏
    hasHomeIndicator: false, // 是否是全面屏
    apps: [],
    ads: [],
    share_title: "", //分享标题
    about_text: "", //关于我们
    ga_id: "",
    ad_config: {
      //广告配置
      adLink: "", //广告链接
      rewardAmount: 0, //奖励
      adFrequency: 0, //频率(小时)
    },
    check_in_config: {
      //签到1-7天分别奖励
      day1: 0,
      day2: 0,
      day3: 0,
      day4: 0,
      day5: 0,
      day6: 0,
      day7: 0,
    },
    welcome_reward: {
      // 欢迎页面随机奖励
      min: 0,
      max: 0,
    },
    user_reward: {
      // 邀请奖励
      regularCoin: 0, //普通金币
      regularBalance: 0, //普通余额
      vipCoin: 0, //会员金币
      vipBalance: 0, //会员余额
    },
    app_link: "", //小程序自身链接
    Phone_url: "", //绑定手机号链接
    bot_username: "", //bot用户名
    coin_name: "", //挖的币名字
    coin_image: "", //挖的币图标
    coin_yield: "", //每秒产出
    claim_limit: "", //最低领取限制
    app_coin_name: "", //自身币名字
    app_coin_image: "", //自身币图标
    app_coin_desc: "", //自身币描述
    fan_image: "", //点点点图片
    welcome_image: "", //欢迎图片
    welcome_connect: false, //是否需要连接钱包
    themes_color: "", //主题色
    app_color: "#eee", //背景色
    partner_image: "", //合作伙伴
    miner_list: [], //矿机列表
    withdraw_limit: "", //最低提现额度
    withdraw_fee: "", //网络手续费
    withdraw_referrals: "", //邀请人数限制
    project_name: "", //项目名字
    whitelist: "", //白名单
    auto_pause_mining: "", //超过n天没使用，自动暂停。单位: 天
    withdraw_amount: {
      //随机提现
      min: 0,
      max: 0,
    },
    miniapp_info: [], // 小程序头部信息
    withdraw_review: false, //是否需要审核
    coin_data: {
      price: 0,
      symbol: "",
    }, // 币的价格
    coin_data_error: false, // 币的价格错误
    okx_reward: 0, // okx奖励
    ton_connect: {}, // ton连接配置
    points_sku: [], //积分商城
    balance_sku: [], //余额商城
    miner_image1: "", //矿机图片1
    miner_image2: "", //矿机图片2
    miner_image3: "", //矿机图片3
    short_domain: "", //短链接的域名
    withdraw_bind: 0, //提现任务人数
    share_add: 0, //分享增加人数
    max_share_count: 0, //最大分享人数
    invite_reward: [], // 邀请任务奖励
    withdraw_chain: "", //提现链
    withdraw_limit_tip: "", //提现限制提示
    first_withdraw_limit_tip: "", //首次提现限制提示
    min_commission: 0, //最小佣金
    withdraw_limit_v1: [], // 提现阶梯
    auto_pay_coin: 0, //自动兑换的币
    auto_pay_coin_image: "", //自动兑换的币图标
    auto_pay_coin_desc: "", //自动兑换的币描述
    withdraw_ladder: [], // 提现阶梯
    withdraw_step: [], // 提现步骤
    withdraw_mode: "", // 提现模式
    pay_skip_tip: "", // 跳过提现提示
    ad_desc: "", // 广告描述
    invoice_list: [], // 积分商城
    post_link: "", // 分享链接
    progress_start: "", // 进度开始
    progress_text: "", // 进度文本
    swipe_config: [
      {
        avatar: "",
        name: "",
        content: "",
      },
    ], // 轮播图图片
    swipe_duration: 0, // 轮播图时间
    contact_us_title: "", // 联系我们标题
    contact_us: [
      {
        avatar: "",
        name: "",
        content: "",
      },
    ], // 联系我们
    xrp_tip: "", // XRP提示
    denominated_coin_img: "",
    denominated_coin: "",
    accelerated_step: [], // 加速步骤
    share_url: "", // 分享链接
    share_btn_type: "", // 分享按钮类型: fb(Facebook) / x(Twitter) / line(Line) / wa(WhatsApp) / msgr(Messenger) / tg(Telegram) / 空(默认tg)
    hasPassedInit: false, // 是否已通过404初始化，用于控制Tabbar显示
    invite_text: "",
    commission_desc: "",
    invite_img: "",
    wallet_tip: "", // 钱包提示
    download_wallet_desc: "", // 下载钱包描述
    miner_max: 0, // 矿机最大数量
    // 用于存储可能的额外属性
    extraConfig: {},
  }),
  actions: {
    setApps(apps) {
      this.apps = apps;
    },
    setAds(ads) {
      this.ads = ads;
    },
    setCoinData(data) {
      this.coin_data = data;
    },
    setDATA(data) {
      //console.log(data);
      for (const key in data) {
        if (key in this.$state) {
          this[key] = data[key];
        } else {
          // 对于state中未定义的属性，将其添加到extraConfig中
          this.extraConfig[key] = data[key];
        }
      }
    },
    setCoinDataError(error) {
      console.log(error);
      this.coin_data_error = error;
    },
    // 添加一个安全的方法来获取配置值
    getConfig(key) {
      if (key in this.$state) {
        return this[key];
      } else if (key in this.extraConfig) {
        return this.extraConfig[key];
      }
      return undefined;
    },
    setShortDomain(domain) {
      this.short_domain = domain;
    },
  },
});
